export const usaOption = { label: "USA", value: "usa", id: "00" };

export const userRoles = [
  { value: "admin", label: "admin" },
  { value: "vip", label: "vip" },
  { value: "member", label: "member" },
];
